module.exports = __webpack_public_path__ + "media/login.e6ba933e.mp4";